module.exports = __webpack_public_path__ + "img/icon-77.880a830d.png";